"use client";

import { usePathname } from "next/navigation";
import Script from "next/script";
import {useContext, useEffect, useState} from "react";
import * as pixel from "../lib/fpixel";
import {Basket} from "../../context/basket";

const FacebookPixel = () => {
    const basket = useContext(Basket);
    const [loaded, setLoaded] = useState(false);
    const [hasInit, setHasInit] = useState(false);
    const pathname = usePathname();
    const setLoadedState = () => {
        if (loaded === false) {
            setLoaded(true);
        }
    }

    useEffect(() => {
        if (!loaded) return;
        if (!hasInit && typeof basket?.data?.customer !== 'undefined') {
            let advancedMatching = {};
            if (typeof basket?.data?.customer?.email_address !== 'undefined') {
                advancedMatching.em = basket.data.customer.email_address;
            }
            if (typeof basket?.data?.customer?.first_name !== 'undefined') {
                advancedMatching.fn = basket.data.customer.first_name;
            }
            if (typeof basket?.data?.customer?.last_name !== 'undefined') {
                advancedMatching.ln = basket.data.customer.last_name;
            }
            if (typeof basket?.data?.customer?.telephone !== 'undefined'
                && basket?.data?.customer?.telephone !== null) {
                let telephone = basket.data.customer.telephone.replace(/[^0-9 ]/g, "");
                if (telephone !== null) {
                    telephone = telephone.replace(/ /g,'');
                }
                advancedMatching.ph = telephone;
            }
            window.fbq("init", pixel.FB_PIXEL_ID, advancedMatching);
            setHasInit(true);
        }

        pixel.pageview();
    }, [pathname, loaded, basket]);

    return (
        <div>
            <Script
                id="fb-pixel"
                src="/static/scripts/meta_pixel.js"
                strategy="afterInteractive"
                onLoad={() => setLoadedState()}
            />
        </div>
    );
};

export default FacebookPixel;